const NotificationTypeEnum = {
  INFO   : 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR  : 'error'
}

export default NotificationTypeEnum
